import { render, staticRenderFns } from "./BaseSpanWrap.vue?vue&type=template&id=82de389a&scoped=true&"
import script from "./BaseSpanWrap.vue?vue&type=script&lang=js&"
export * from "./BaseSpanWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82de389a",
  null
  
)

export default component.exports